<div class="context-view" cf>
  @if (loadunitId() !== null) {
    <div class="context-header">
      <div class="context-title">{{ 'MASTERDATA.LOADUNIT.CONTEXT.EDIT' | translate }} {{ loadunitId() }}</div>
      <div class="f-1"></div>
      <div class="context-corner">
        <dx-button class="small-button" icon="close" (onClick)="close()"></dx-button>
      </div>
    </div>
  } @else {
    <div class="context-header">
      <div class="context-title">{{ 'MASTERDATA.LOADUNIT.CONTEXT.CREATE' | translate }}</div>
      <div class="f-1"></div>
      <div class="context-corner">
        <dx-button class="small-button" icon="close" (onClick)="close()"></dx-button>
      </div>
    </div>
  }

  @if (!isLoading()) {
    <form>
      <dx-form
        id="form"
        class="form last plain-styled-form"
        [formData]="formData"
        labelMode="floating"
        [(isDirty)]="isDirty">
        <dxi-item itemType="group" [colCount]="2">
          <dxi-item dataField="id" editorType="dxTextBox" [visible]="type === 'edit'" [isRequired]="type === 'edit'">
            <dxo-label [text]="'MASTERDATA.LOADUNIT.DTO.ID' | translate"> </dxo-label>
          </dxi-item>
          <dxi-item dataField="name" editorType="dxTextBox" [isRequired]="true" [editorOptions]="{ maxLength: 20 }">
            <dxo-label [text]="'MASTERDATA.LOADUNIT.DTO.NAME' | translate"> </dxo-label>
          </dxi-item>
        </dxi-item>

        <dxi-item itemType="group" [colCount]="2">
          <dxi-item dataField="maxLoad" editorType="dxNumberBox" [isRequired]="true">
            <dxo-label [text]="'MASTERDATA.LOADUNIT.DTO.MAXLOAD' | translate"> </dxo-label>
          </dxi-item>

          <dxi-item dataField="maxVolume" editorType="dxNumberBox" [isRequired]="true">
            <dxo-label [text]="'MASTERDATA.LOADUNIT.DTO.MAXVOLUME' | translate"> </dxo-label>
          </dxi-item>
        </dxi-item>

        <dxi-item itemType="group" [colCount]="2">
          <dxi-item
            dataField="type"
            editorType="dxSelectBox"
            [editorOptions]="{ dataSource: loadunitTypes, displayExpr: 'display', valueExpr: 'value' }"
            [isRequired]="true">
            <dxo-label [text]="'MASTERDATA.LOADUNIT.DTO.TYPE' | translate"> </dxo-label>
          </dxi-item>
        </dxi-item>
      </dx-form>
    </form>

    <div class="container">
      <dx-button
        class="delete-button"
        type="danger"
        [visible]="type === 'edit'"
        [text]="'SHARED.DELETE' | translate"
        (onClick)="delete()">
      </dx-button>

      <dx-button class="submit-button" (onClick)="save()" [disabled]="!isDirty" [text]="'SHARED.SAVE' | translate">
      </dx-button>
    </div>
  } @else {
    <app-loader></app-loader>
  }
</div>
